import React from "react";
// component
import Email from "assets/icons/mail.svg";
import Call from "assets/icons/phone.svg";
import Message from "assets/icons/sms.svg";
import { mailTo, phoneTo, smsTo } from "utils/contactTo";
// direct import
import { useStyles } from "./style";

const ContactActions = ({ phone, email, content }) => {
  const classes = useStyles();
  return (
    <div className={classes.contactWrapper}>
      <a
        className={`${classes.contactBtn} ${!phone ? classes.disabled : ""}`}
        href={phoneTo({ phone })}
      >
        <img src={Call} alt="Call" className={classes.icon} />
        Call
      </a>
      <a
        className={`${classes.contactBtn} ${!phone ? classes.disabled : ""} ${
          classes.btnMargin
        }`}
        href={smsTo({ phone, content })}
      >
        <img src={Message} alt="Message" className={classes.icon} />
        Message
      </a>
      <a
        className={`${classes.contactBtn} ${!email ? classes.disabled : ""}`}
        href={mailTo({ email, content })}
      >
        <img src={Email} alt="Email" className={classes.icon} />
        Email
      </a>
    </div>
  );
};

export default ContactActions;
